module.exports = __webpack_public_path__ + "img/un-active-points.d101522.svg";